export default function BeachLifePage() {
  return (
    <div className="font-saol">
      {/* IMAGE + TEXT OVERLAY */}
      <div className="relative w-full h-screen overflow-hidden border-black border-b-2 px-6 md:px-12 py-6">
        {/* Background Image */}
        <img
          src="/4.webp"
          alt="Beach Life"
          className="w-full h-full object-cover absolute inset-0 -z-10"
        />

        {/* Top Center BEACH */}
        <div className="absolute top-6 left-1/2 transform -translate-x-1/2 text-white text-[48px] md:text-[120px] font-normal tracking-tight">
          BEACH
        </div>

        {/* Bottom Center BEACH (rotated) */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 rotate-180 text-white text-[48px] md:text-[120px] font-normal tracking-tight">
          BEACH
        </div>

        {/* Left LIFE (vertical) */}
        <div className="absolute top-1/2 left-4 transform -translate-y-1/2 rotate-90 text-white text-[48px] md:text-[120px] font-normal">
          LIFE
        </div>

        {/* Right LIFE (vertical) */}
        <div className="absolute top-1/2 right-4 transform -translate-y-1/2 -rotate-90 text-white text-[48px] md:text-[120px] font-normal">
          LIFE
        </div>
      </div>

      {/* TEXT SECTION BELOW */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-6 md:px-24 py-12 text-black">
        <p className="text-base md:text-lg leading-relaxed font-saol max-w-3xl">
          Bountiful Days Of Ease And Entertainment Await Your Arrival In NAMMOS Dubai. Bespoke Unequaled Services Will Offer You A Full-On Pampering Experience While On The Beach, The Bars And The Restaurant. There Is Nothing You Will Miss From The World, Since We Bring The World To You.
        </p>
        <p className="text-base md:text-lg leading-relaxed font-saol max-w-md">
          Rare Tastes. Impeccable Services. Luxurious Summer Lifestyle.
        </p>
      </div>
    </div>
  );
}
